module.exports = __webpack_public_path__ + "static/media/bsl-logo-mini-color.94d356f4.png";